// only create 1 per app but re-mount it as necessary
var stripe;
var stripeCard;

const INVOICE_DAYS_UNTIL_DUE = 30;
const RMA_SKU_INDICATOR = 'return-label';
const PREMIUM_PLAN_PRODUCT = 'prod_GphxV14RtoEZnx';

export function getStripeCard() {
  if (!stripe && !stripeCard) {
    stripe = Stripe(STRIPE_KEY);
    stripeCard = stripe.elements().create('card');
  }
  return stripeCard;
}

export function getToken(card) {
  return stripe.createToken(card).then((result) => {
    if (result.error) {
      throw result.error.message;
    } else {
      return result.token;
    }
  });
}

export function parseBilling(billing) {
  var result = {
    billing: billing,
    bankOnFile: null,
    cardOnFile: null,
    paidInvoices: [],
    outstandingInvoices: [],
    trialSub: null,
    daysUntilSuspend: 0,
    subscriptions: [],
    isBilledMonthly: false,
    formattedAddress: '',
    isPremiumPlan: false,
  };

  // Parse cards
  if (billing.stripe_token) {
    var cardId = billing.stripe_token;
    var cards = billing.sources.data;
    var card = _.find(cards, { id: cardId });
    if (card.object == 'card') {
      result.cardOnFile = card;
    } else if (card.object == 'bank_account') {
      result.bankOnFile = card;
    }
  }

  // Parse Invoices
  var maxDaysPastDue = 0;
  if (billing.invoices && billing.invoices.data.length) {
    billing.invoices.data.forEach((inv) => {
      if (inv.status == 'void') {
        // Skip void invoices
      } else if (inv.status == 'draft' && !inv.closed) {
        // Skip invoices that are not yet viewable
      } else {
        inv.usage = [];
        if (inv.lines) {
          _.forEach(inv.lines.data, (line) => {
            if (line.plan && line.plan.usage_type == 'metered') {
              inv.usage.push({
                type: line.plan.metadata.usage_type,
                periodStart: line.period.start,
                periodEnd: line.period.end,
                subscriptionItemId: line.subscription_item,
                plan: line.plan,
              });
            }
          });
        }
        if (inv.status == 'paid') {
          result.paidInvoices.push(inv);
          return;
        }
        inv.due_date = inv.due_date || inv.date;
        if (inv.due_date < new Date() && inv.billing == 'send_invoice') {
          inv.days_past_due = moment(new Date()).diff(inv.due_date * 1000, 'days');
          maxDaysPastDue = Math.max(maxDaysPastDue, inv.days_past_due);
        }
        if (inv.billing == 'charge_automatically') {
          if (inv.attempted && (inv.attempt_count > 1 || inv.next_payment_attempt)) {
            inv.detailedStatus = 'failed';
          } else if (!inv.attempted) {
            inv.detailedStatus = 'awaiting_payment';
          } else {
            inv.detailedStatus = 'pending';
          }
        } else {
          inv.detailedStatus = 'awaiting_payment';
        }
        result.outstandingInvoices.push(inv);
      }
    });
  }

  if (maxDaysPastDue > 0) {
    result.daysUntilSuspend = Math.max(INVOICE_DAYS_UNTIL_DUE - maxDaysPastDue, 0);
  }

  // Parse subscriptions
  result.subscriptions = [];
  if (billing.subscriptions && billing.subscriptions.total_count) {
    billing.subscriptions.data.forEach((sub) => {
      sub.total_amount = 0;
      if (sub.items.data[0] && sub.items.data[0].plan.interval == 'year') {
        sub.annual_renewal = new Date(sub.current_period_end * 1000);
      } else if (sub.items.data[0] && sub.items.data[0].plan.interval == 'month') {
        result.isBilledMonthly = true;
      }
      sub.items.data.forEach((item) => {
        item.plan.name = item.plan.metadata.display_name || item.plan.nickname || item.plan.id;
        item.plan.quantity = item.quantity || sub.quantity || 1;
        sub.total_amount += item.plan.amount * item.plan.quantity;
        if (item.plan.usage_type == 'metered') {
          sub.hasUsage = true;
        }
        if (item.plan.product == PREMIUM_PLAN_PRODUCT) {
          result.isPremiumPlan = true;
        }
      });
      if (sub.discount && sub.discount.coupon) {
        if (sub.discount.coupon.percent_off) {
          sub.discount.coupon.amount_off =
            (sub.total_amount * sub.discount.coupon.percent_off) / 100;
        }
        sub.total_amount -= sub.discount.coupon.amount_off;
      }
      result.subscriptions.push(sub);
      if (sub.status == 'trialing') {
        result.trialSub = sub;
      }
    });
  }

  // Other utilies
  cleanAddress(result.billing);
  if (
    billing.address != '' &&
    billing.city != '' &&
    billing.state != '' &&
    billing.postal_code != ''
  ) {
    result.formattedAddress = `${billing.address}\n${billing.city}, ${billing.state} ${billing.postal_code} ${billing.country}`;
  } else {
    result.formattedAddress = 'No Billing Address';
  }

  return result;
}

export function hasRMAItem(proposal) {
  let hasRMA = false;
  _.forEach(proposal.products.invoice_items, (item) => {
    if (item.stripe_price.lookup_key.toLowerCase().indexOf(RMA_SKU_INDICATOR) >= 0) {
      hasRMA = true;
    }
  });
  return hasRMA;
}

function cleanAddress(addressObj) {
  if (!addressObj) return;
  if (addressObj.address == 'Unknown') addressObj.address = '';
  if (addressObj.city == 'Unknown') addressObj.city = '';
  if (addressObj.state == 'Unknown') addressObj.state = '';
  if (addressObj.postal_code == 'Unknown') addressObj.postal_code = '';
  if (addressObj.country == 'Unknown') addressObj.country = '';
  return addressObj;
}



// WEBPACK FOOTER //
// ./app/utils/stripe.js